export default {
  buttons: {
    more_payment_methods: 'Más métodos de pago',
  },
  toasts: {
    processing: 'Procesando datos de pago. Le informaremos cuando el proceso finalice.',
    failed: 'Error al procesar los datos de pago. Pruebe otro método de pago.',
    failed_to_load: 'No se pudo cargar el formulario de pago. Recarga la página e inténtalo de nuevo.',
    failed_to_save_payment_method: 'Error al guardar el método de pago',
    failed_to_create_checkout_session: 'Algo salió mal, inténtelo de nuevo',
  },
};
